export default __webpack_public_path__ + "static/media/laundry2-after-480w.9568a17f.webp";